import { render, staticRenderFns } from "./UpdateOnboardPFACModal.vue?vue&type=template&id=069c6a50&scoped=true"
import script from "./UpdateOnboardPFACModal.vue?vue&type=script&lang=js"
export * from "./UpdateOnboardPFACModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateOnboardPFACModal.vue?vue&type=style&index=0&id=069c6a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c6a50",
  null
  
)

export default component.exports